import { SWRConfiguration } from 'swr';
import { logError, logGraphQLError } from './onErrorUtils';
import { SWRMutationConfiguration } from 'swr/mutation';

export const swrConfig: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  shouldRetryOnError: true,
  errorRetryCount: 3,
  errorRetryInterval: 1000,

  onError: (error: any, key: string) => {
    logError(error, key);
  },

  onSuccess: (data: any, key: string) => {
    if (data?.errors?.length) {
      const [firstError] = data.errors;
      logGraphQLError(key, firstError?.message || 'Unknown GraphQL Error');
    }
  },

  onLoadingSlow: (key: string, config) => {
    console.info(`Slow loading ${key}`, config);
  },

  onErrorRetry: (error: any, key: string, config, revalidate, { retryCount }) => {
    const NO_RETRY_STATUSES = [401, 403, 404];
    if (NO_RETRY_STATUSES.includes(error?.status ?? 0)) return;
    if (retryCount >= 3) return;
    console.info(`Error querying ${key}. Retrying ${retryCount}/3`, config);
  },
};

export const mutationConfig: SWRMutationConfiguration<any, any> = {
  onSuccess: (data: any, key: string) => {
    if (data?.errors?.length) {
      const [firstError] = data.errors;
      logGraphQLError(key, firstError?.message || 'Unknown GraphQL Error');
    }
  },

  onError: (error: any, key: string) => {
    logError(error, key);
  },
};
